// extracted by mini-css-extract-plugin
export var container = "_uk-0";
export var table = "_uk-2";
export var tableWrapper = "_uk-1";